export default __webpack_public_path__ + "static/media/miami-ice.e8350529.jpeg";